/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import PropTypes from 'prop-types';
import { Button, ScrollToHelper } from 'sarsaparilla';
import CellCoverageIcon from '../CellCoverageIcon';
import { calculateAverageCellSignal, describeCoverage } from '../../utils/cellCoverage';

export default function CellSummary({ aggregate, wrapper: Tag = 'div' }) {
    if (!aggregate || !aggregate.aggregate_cell_coverage_ratings) {
        return null;
    }
    const cellAverage = calculateAverageCellSignal(
        aggregate.aggregate_cell_coverage_ratings
    );
    const descriptArray = describeCoverage(cellAverage).split(' ');
    descriptArray.splice(1, 0, 'Mobile');

    const handleScrollDown = () => {
        const el = document.getElementById(
            'rating-review-inventory-review-section-heading'
        );
        const header = document.getElementById('nav-header-container');
        if (!header || !el) return;
        const currentPosition = window.scrollY;
        const y = el.getBoundingClientRect().top - header.offsetHeight + currentPosition;
        ScrollToHelper.scrollToY(y);
        el.focus();
    };

    return (
        <Tag className="ratReview-cell-summary-wrapper">
            <Button appearance="link" onClick={handleScrollDown}>
                <CellCoverageIcon value={cellAverage} size="sm" />
                {descriptArray.join(' ')}
            </Button>
        </Tag>
    );
}

CellSummary.propTypes = {
    aggregate: PropTypes.shape({
        location_id: PropTypes.string,
        average_rating: PropTypes.number,
        number_of_ratings: PropTypes.number,
        star_counts: PropTypes.shape({
            1: PropTypes.number,
            2: PropTypes.number,
            3: PropTypes.number,
            4: PropTypes.number,
            5: PropTypes.number,
        }),
        aggregate_cell_coverage_ratings: PropTypes.arrayOf(
            PropTypes.shape({
                carrier: PropTypes.string,
                average_rating: PropTypes.number,
                number_of_ratings: PropTypes.number,
            })
        ),
    }),
    wrapper: PropTypes.oneOf(['div', 'li']),
};
